// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 502) return "static/js/502.b4885f4b4.chunk.js";
	if (chunkId === 777) return "static/js/recorder.b4885f4b4.chunk.js";
	if (chunkId === 12) return "static/js/profiler.b4885f4b4.chunk.js";
	if (chunkId === 331) return "static/js/331.b4885f4b4.chunk.js";
	if (chunkId === 38) return "static/js/38.b4885f4b4.chunk.js";
	if (chunkId === 506) return "static/js/506.b4885f4b4.chunk.js";
	if (chunkId === 420) return "static/js/420.b4885f4b4.chunk.js";
	if (chunkId === 854) return "static/js/854.b4885f4b4.chunk.js";
	if (chunkId === 725) return "static/js/725.b4885f4b4.chunk.js";
	if (chunkId === 946) return "static/js/946.b4885f4b4.chunk.js";
	if (chunkId === 916) return "static/js/916.b4885f4b4.chunk.js";
	// return url for filenames based on template
	return undefined;
};